var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var QboIcon_1;
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { until } from "lit/directives/until.js";
const iconMap = new Map();
// qbo modules
iconMap.set('accounting', 'currency-dollar');
iconMap.set('collection', 'tag');
iconMap.set('document', 'file-earmark');
iconMap.set('export', 'database-down');
iconMap.set('import', 'database-up');
iconMap.set('message', 'envelope');
iconMap.set('process', 'building-gear');
iconMap.set('score', 'file-spreadsheet');
iconMap.set('task', 'list-check');
iconMap.set('workflow', 'diagram-2');
iconMap.set('security', 'lock');
// generic icons
iconMap.set('refresh', 'arrow-repeat');
iconMap.set('cut', 'scissors');
iconMap.set('copy', 'copy');
iconMap.set('paste', 'clipboard');
iconMap.set('delete', 'trash');
iconMap.set('up', 'arrow-up-circle');
iconMap.set('down', 'arrow-down-circle');
iconMap.set('left', 'arrow-left-circle');
iconMap.set('right', 'arrow-right-circle');
iconMap.set('copy', 'trash');
iconMap.set('maximize', 'arrow-down-circle');
iconMap.set('minimize', 'arrow-right-circle');
iconMap.set('normal', 'arrow-down-right-circle');
iconMap.set('upload', 'upload');
iconMap.set('download', 'download');
iconMap.set('folder', 'folder2');
iconMap.set('folder-open', 'folder2-open');
iconMap.set('pdf', 'filetype-pdf');
iconMap.set('audio', 'headphones');
iconMap.set('video', 'camera-video');
iconMap.set('headset', 'headphones');
iconMap.set('warning', 'exclamation-triangle');
// Renders an SVG icon based on the type attribute.
let QboIcon = class QboIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'icon';
        this.icon = null;
        this.height = '1rem';
        this.width = '1rem';
        this.viewbox = '0 0 1em 1em';
        this.fill = 'currentColor';
        this.backgroundColor = null;
        this.disabled = false;
        this.renderInHost = true;
        this.selected = false;
        this.allIcons = undefined;
    }
    static { QboIcon_1 = this; }
    static { this.map = iconMap; }
    // = '/ui/images/icons.svg';
    // Getter to retrieve the `qbo4-basepath` meta tag value
    static get spriteUrl() {
        const metaTag = document.querySelector('meta[name="qbo4-basepath"]');
        const basePath = metaTag?.getAttribute('value') || '';
        return `${basePath}/ui/images/qbo-icons.svg`;
    }
    connectedCallback() {
        this.type ??= 'icon';
        super.connectedCallback();
        if (this.type === 'toggle') {
            this.addEventListener('click', this.toggle);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.toggle);
    }
    toggle() {
        this.selected = !this.selected;
        this.dispatchEvent(new CustomEvent(this.selected ? 'selected' : 'delected', { bubbles: true, composed: true }));
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('selected') && this.type === 'toggle') {
            this.setAttribute('aria-pressed', this.selected ? 'true' : 'false');
        }
    }
    async loadIcons() {
        if (this.allIcons)
            return this.allIcons;
        try {
            // Adjust this path to point to the correct location of bootstrap-icons.svg
            const response = await fetch(this.sprite ?? QboIcon_1.spriteUrl);
            const svgText = await response.text();
            // Parse the SVG file
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
            // Find all `<symbol>` elements and extract their `id` attributes
            const symbols = svgDoc.querySelectorAll('symbol');
            this.allIcons = Array.from(symbols).map(symbol => symbol.id);
        }
        catch (error) {
            console.error('Error loading icons:', error);
        }
        return this.allIcons;
    }
    renderStandard(component) {
        return html `<div class="row">
${Array.from(iconMap.keys()).map(k => html `<div class="col-3"> 
        <li class="list-unstyled">
            <qbo-icon 
                .height=${component.height} 
                .width=${component.width} 
                .viewbox=${component.viewbox} 
                icon="${k}" 
                .fill=${component.fill} 
                .backgroundColor=${component.backgroundColor}>
            </qbo-icon> ${k}
        </li>
    </div>`)}`;
    }
    async renderAll(component) {
        await component.loadIcons();
        if (this.allIcons === undefined)
            return html `No icons found`;
        return html `
<div class="row">
    ${this.allIcons.map(k => html `
        <div class="col-md-4"> 
            <li class="list-unstyled">
                <qbo-icon 
                    .height=${component.height} 
                    .width=${component.width} 
                    .viewbox=${component.viewbox} 
                    icon="${k}" 
                    .fill=${component.fill} 
                    .backgroundColor=${component.backgroundColor}>
                </qbo-icon> ${k}
            </li>
        </div>
    `)}
</div>`;
    }
    renderIcon(component) {
        if (component.icon == null || component.icon === undefined) {
            console.warn('qbo-icon: icon attribute is required');
            component.icon = 'warning';
        }
        const id = iconMap.has(component.icon) ? iconMap.get(component.icon) : component.icon;
        return html `<svg width="${component.width}" height="${component.width}" fill="${component.fill}" ?class=${component.getAttribute('class')}><use href="${component.sprite ?? QboIcon_1.spriteUrl}#${id}"></use></svg>`;
    }
    //renderButton(component: any) {
    //    return html`<button type="button" ?disabled=${component.disabled}>${component.renderIcon(component)}</button>`;
    //}
    render() {
        switch (this.type) {
            case 'icon': return this.renderIcon(this);
            case 'button': return this.renderIcon(this);
            case 'toggle': return this.renderIcon(this);
            case 'standard': return this.renderStandard(this);
            case 'all': return html `${until(this.renderAll(this), html `Loading...`)}`;
            default: return this.renderIcon(this);
        }
    }
};
__decorate([
    property(),
    __metadata("design:type", String)
], QboIcon.prototype, "type", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboIcon.prototype, "sprite", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboIcon.prototype, "icon", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboIcon.prototype, "height", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboIcon.prototype, "width", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboIcon.prototype, "viewbox", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboIcon.prototype, "fill", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboIcon.prototype, "backgroundColor", void 0);
__decorate([
    property(),
    __metadata("design:type", Boolean)
], QboIcon.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], QboIcon.prototype, "renderInHost", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Boolean)
], QboIcon.prototype, "selected", void 0);
QboIcon = QboIcon_1 = __decorate([
    customElement('qbo-icon')
], QboIcon);
export { QboIcon };
